import { render, staticRenderFns } from "./NoInsuranceBlurb.vue?vue&type=template&id=0236bd2b&scoped=true&"
import script from "./NoInsuranceBlurb.vue?vue&type=script&lang=js&"
export * from "./NoInsuranceBlurb.vue?vue&type=script&lang=js&"
import style0 from "./NoInsuranceBlurb.vue?vue&type=style&index=0&id=0236bd2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.registry.npmjs.org/vue-loader/15.9.8_css-loader@3.6.0+webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0236bd2b",
  null
  
)

export default component.exports